/**
 * Feedback and waitlist API operations
 */
import { request, toProblem, unwrapData } from './base';
import type { ApiResponse, FeedbackSubmitData, WaitlistSubmitData } from './types';

export interface MessageResult {
  message: string;
  meta?: ApiResponse<unknown>['meta'];
}

const toMessageResult = (
  response: ApiResponse<{ message?: string }>,
  fallback: string
): MessageResult => {
  const data = unwrapData(response);
  return {
    message: data.message ?? fallback,
    meta: response.meta,
  };
};

/**
 * Submit feedback
 */
export const submitFeedback = async (feedbackData: FeedbackSubmitData): Promise<MessageResult> => {
  try {
    const response = await request<{ message?: string }>('/feedback/submit/', {
      method: 'POST',
      body: JSON.stringify(feedbackData),
    });

    return toMessageResult(response, 'Feedback submitted successfully');
  } catch (error) {
    throw toProblem(error);
  }
};

/**
 * Submit waitlist entry
 */
export const submitWaitlistEntry = async (
  waitlistData: WaitlistSubmitData
): Promise<MessageResult> => {
  try {
    const response = await request<{ message?: string }>('/waitlist/signup/', {
      method: 'POST',
      body: JSON.stringify(waitlistData),
    });

    return toMessageResult(response, 'Waitlist submission received successfully');
  } catch (error) {
    throw toProblem(error);
  }
};
